export const repeatField = 'repeat-ai-modal-repeat-field';
export const stopAfterField = 'repeat-ai-modal-stop-after-field';
